import React from 'react';
import { useTheme } from 'styled-components';

import { HabitDetailDesktopCard } from '../habit-detail-desktop-card';
import { HabitDetailMobileCard } from '../habit-detail-mobile-card';

export type HabitDetailCardProps = React.ComponentProps<
  typeof HabitDetailDesktopCard
> &
  React.ComponentProps<typeof HabitDetailMobileCard>;

export const HabitDetailCard: React.FC<HabitDetailCardProps> = React.memo(
  ({ habit, onClick, weekDate, isSortable, sortableId, isDragPreview }) => {
    const theme = useTheme();

    return theme.isMobile ? (
      <HabitDetailMobileCard
        habit={habit}
        onClick={onClick}
        weekDate={weekDate}
        isSortable={isSortable}
        sortableId={sortableId}
        isDragPreview={isDragPreview}
      />
    ) : (
      <HabitDetailDesktopCard
        habit={habit}
        onClick={onClick}
        weekDate={weekDate}
        isSortable={isSortable}
        sortableId={sortableId}
        isDragPreview={isDragPreview}
      />
    );
  },
);
